import BaseDialog from "@/components/dialog/BaseDialog";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import React, { useState, useEffect } from 'react'

import { ChevronDownIcon } from '@heroicons/react/20/solid'

const items = [


  { name: 'Taak annuleren', href: '#' },
]



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function TodoView(props) {
    let firstAction = null;
    let otherActions = [];
    let data = (props?.data) ? props?.data : []; 
     const sanitizedData = () => ({
        __html: (data?.description)
      })
    
    const cancelEvent = (event) => {
        if(props?.closeModalEvent) {
            props.closeModalEvent();
        }
    }

    const actionEvent = (event, action) => {
        if(props?.nextActionEvent) {
            props.nextActionEvent(action);
        }
    }
    
    const getActionMenuButton= () => {
        let objKeys = Object.keys(data?.nextActions);
        
        objKeys.map( (itemKey) => {
            let actionItem = data.nextActions[itemKey]
            let order = (actionItem?.order) ? ( parseInt(actionItem?.order)-1) : otherActions.length;
            if(order == 0) {
                firstAction = actionItem;
            } else {
                otherActions[order] = actionItem
            }
        })
        
        return buildButtonElements();
    }
    
    const buildButtonElements = () => {
        
        return (
    <div className="inline-flex rounded-md shadow-xs mr-2">
      <button
        onClick={(event) => actionEvent(event, firstAction)}
        type="button"
        className="relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold text-white shadow-xs bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 focus:z-10"
      >
        {firstAction.label}
      </button>
      <Menu as="div" className="relative -ml-px block">
        <MenuButton className="relative inline-flex items-center rounded-r-md px-2 py-2 text-white ring-gray-300 ring-inset bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 focus:z-10">
          <span className="sr-only">Open options</span>
          <ChevronDownIcon aria-hidden="true" className="size-5" />
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 -mr-1 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
        >
          <div className="py-1">
            {otherActions.map((item) => (
              <MenuItem key={item.label}>
              <button
                onClick={(event) => actionEvent(event, item)}
                  className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
                >
                  {item.label}
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    </div>
        );
    }
    
    return (
        <div className="grid grid-cols-12 gap-2">
            <div className="col-span-8 ">
        <h1 className="font-bold mb-2">{data?.name}</h1>
        <div dangerouslySetInnerHTML={sanitizedData()} />
        </div>
        <div className="col-span-4 ">
            <div className="flex flex-row-reverse ">

        {data?.nextActions && 
            getActionMenuButton()
        }

                



         <button
         onClick={(event) => cancelEvent(event)}
        type="button"
        className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 mr-2"
      >
        Annuleren
      </button>                
                
            </div>
        </div>
        </div>
    )
}